import i18n from "@packages/i18n/config";

export const tC = (contentLanguage: string, key: string, options?: any) => {
  const appObj = i18n.getDataByLanguage(contentLanguage)?.app;
  if (!appObj) return i18n.t(key, options);

  // Support multiple levels of dot notation in key
  const keys = key.split(".");
  let value: any = appObj;
  for (const k of keys) {
    if (value && typeof value === "object" && value !== null && k in value) {
      value = value[k];
    } else {
      return i18n.t(key, options);
    }
  }

  if (options && typeof value === "string") {
    Object.keys(options).forEach((k) => {
      value = value.replace(new RegExp(`{{\\s*${k}\\s*}}`, "g"), options[k]);
    });
  }

  return value;
};
